/**
 * Shared chip metrics — the size/typography half of a list-view chip, with no
 * color or radius of its own.
 *
 * Tag chips, certification chips and the chip-shaped popover triggers (e.g. the
 * competence path selector) sit side by side in the same filter row, so they
 * must resolve to the SAME height and font size. They used to hardcode their
 * own padding/text classes and drifted apart (a 22px trigger next to a 26px
 * chip); anything that joins such a row should use these instead.
 */
export const chipSizeClasses = (size: "md" | "sm" = "md") =>
	size === "sm"
		? "gap-1 px-2 py-0.5 type-label leading-5"
		: "gap-1.5 px-2.5 py-1 type-body leading-6";

/**
 * The chip's trailing affordance (remove ✕, dropdown chevron). Fixed 20px box:
 * it is what defines the chip's height, so every chip in a row carries one —
 * or none of them do.
 */
export const chipAffordanceClasses = "flex h-5 w-5 shrink-0 items-center justify-center";
